'use client';

import { useEffect } from 'react';
import { sentry } from '@/services/sentry';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <h2>Something went wrong</h2>
      </body>
    </html>
  );
}
